import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../../config';
import { LoanSearchPoolResponse } from '../types';

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  queryParams: string;
};
const apiClientConfig: ApiClientConfig = {
  timeout: config.validationMasterPoolAPi.requestTimeout
};
const inventoryTimeout: number = config.validationMasterPoolAPi.requestTimeout;
const masterPoolSearchResultDataUrl: string = config.validationMasterPoolAPi.urls.searchResult;

export const getMasterPoolSearchResultTableData = async ({
  authenticationContext,
  queryParams
}: RequestProps): Promise<LoanSearchPoolResponse[]> => {
  try {
    const masterPoolSearchResultDataUrlWithParams = masterPoolSearchResultDataUrl + queryParams;
    const response = await ApiClient(authenticationContext, apiClientConfig).getWithAuth(
      masterPoolSearchResultDataUrlWithParams,
      { timeout: inventoryTimeout }
    );
    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error(`Error getting pool search result table data, ${err!!}`);
  }
};
